<template>
  <div class="form-container">
    <el-form ref="form" :model="user" label-width="80px">
      <el-form-item label="姓名">
        <el-input v-model="user.name"></el-input>
      </el-form-item>
      <el-form-item label="Email">
        <el-input v-model="user.email"></el-input>
      </el-form-item>
      <el-form-item label="帳號">
        <el-input v-model="user.username" :disabled="user.id !== 0"></el-input>
      </el-form-item>
      <el-form-item v-if="showPasswordEdit" label="密碼">
        <el-input type="password" v-model="user.newPassword"></el-input>
      </el-form-item>
      <el-form-item v-if="showPasswordEdit" label="確認密碼">
        <el-input type="password" v-model="user.newPasswordCheck"></el-input>
      </el-form-item>
      <el-form-item v-if="showRoleEdit" label="權限">
        <el-select v-model="user.role" placeholder="請選擇權限">
          <el-option label="管理員" value="Admin"></el-option>
          <el-option label="北美館志工 A 組" value="VolunteerA"></el-option>
          <el-option label="北美館志工 B 組" value="VolunteerB"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button plain @click="submitUpdate">更新並儲存</el-button>
        <el-button plain @click="goBack">返回至上一層</el-button>
        <el-button plain v-if="selfAccount === false" @click="deleteAccount">捨棄這筆資料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { getUserById, createUser, updateUserById, deleteUserById, resetUserPassword } from "../../api/user";

  export default {
    name: "AccountEdit",
    data() {
      return {
        selfAccount: false,
        user: {
          id: 0,
          username: "",
          email: "",
          name: "",
          role: "",
          newPassword: undefined,
          newPasswordCheck: undefined
        }
      }
    },
    watch: {
      $route(to, from) {
        this.initData()
      }
    },
    computed: {
      showPasswordEdit: function () {
        return (this.user.id === 0 || this.selfAccount)
      },
      showRoleEdit: function () {
        if (this.user.username.includes('tfam.offical.app')) {
          return false
        } else {
          return (this.user.id === 0 || this.selfAccount === false)
        }
      }
    },
    methods: {
      initData() {
        console.log('initData');
        if (this.$route.path.includes("account")) {
          const user = Object.assign({}, this.$store.getters.user);
          user.newPassword = undefined;
          user.newPasswordCheck = undefined;
          this.user = user;
          this.selfAccount = true;
        } else if (parseInt(this.$route.params.id) === 0){
          console.log(this.$route.params.id);
          this.selfAccount = false
        } else {
          this.getAccountData(parseInt(this.$route.params.id))
        }
      },
      goBack() {
        this.$router.back(-1)
      },
      getAccountData(userId) {
        getUserById(userId).then(response => {
          this.user = response.data;
        }).catch(err => {
        })
      },
      submitUpdate() {
        if (this.user['id'] === 0) {
          console.log('CREATE ACCOUNT');
          const submitUser = {
            name: this.user.name,
            username: this.user.username,
            email: this.user.email,
            password: this.user.newPassword,
            role: this.user.role
          };
          createUser(submitUser).then(response => {
            this.user = response.data;
          }).catch(err => {
          })
        } else {
          const submitUser = {
            name: this.user.name,
            email: this.user.email,
            role: this.user.role
          };
          if (this.selfAccount) {
            console.log('UPDATE SELF ACCOUNT');
            updateUserById(this.user.id, submitUser).then(response => {
              if (this.user.newPassword && this.user.newPasswordCheck) {
                console.log('CHANGE PASSWORD');
                resetUserPassword(this.user.id, this.user.newPassword).then(response => {
                  alert('密碼修改成功，重新登入');
                  this.$router.push({
                    path: '/'
                  })
                }).catch(err => {
                  this.user = response.data;
                });
              } else {
                this.user = response.data;
                console.log('NOT CHANGE PASSWORD');
              }
            }).catch(err => {
            });
          } else {
            console.log('UPDATE ACCOUNT ' + this.user.id);
            updateUserById(this.user.id, submitUser).then(response => {
              this.user = response.data;
            }).catch(err => {
            })
          }
        }
      },
      deleteAccount() {
        if (confirm('確定要捨棄這筆資料嗎？\n(捨棄的資料將無法復原。)')) {
          if (this.user['id'] === 0) {
          } else {
            deleteUserById(this.user.id).then(response => {
              this.$router.push({
                path: '/staffs'
              })
            }).catch(err => {
            })
          }
        }
      }
    },
    mounted() {
      this.initData();
    }
  }
</script>

<style lang="scss">
</style>

